import React, {useCallback, useContext} from 'react'
import GESD_LOGO from '../../assets/logos/gesd_logo_en.svg'

import BreadCrumb from '../BreadCrumb/BreadCrumb'
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from "@fortawesome/free-solid-svg-icons"
import { Button } from 'react-bootstrap';
import { DashboardContext } from '../../views/layouts/DashboardLayout'
import {SocketContext} from "../../context/socket";
import {useAuth} from "../../lib/auth";
import {useTranslation} from "react-i18next";
import axios from "../../utils/axios";
import * as API from "../../utils/api";
import {removeUserData} from "../../utils/common";

const AppBar = ({hasDrawer, onAppBarToggle, onControlPanelToggle}) => {
    const {t} = useTranslation()

    const socket = useContext(SocketContext)
    const {user, access_token, refresh_token, logout} = useAuth()

    const handlLogoutEvent = () => {
        const body = { }
        if(refresh_token){
            body["refresh"] = refresh_token
        }

        axios.post(API.LOGOUT_API, body)
        .then((res) => {
            console.log(res);
        })
        .catch((err)=>{
            window.alert(err);
        })
        .finally((data)=>{
            logout()
            if(socket)
                socket.disconnect()
        })
    }

    const onLogoutButtonClick = () => {
        // Disconnect socket and clean credential
        // if(socket)
        //     socket.disconnect()
        handlLogoutEvent()
    }

    const renderDrawerButton = useCallback(() => {
        if(hasDrawer){
            return (
                <button className="navbar-toggler" type="button" onClick={onAppBarToggle}>
                    <span className="navbar-toggler-icon"></span>
                </button>
            )
        }else{
            return null
        }
    },[hasDrawer])

    const renderRightPanel = () => {
        return (
            <div className="d-flex">
                {renderUserPanel()}
                {renderLogo()}
            </div>
        )
    }

    const renderLogo = () => {
        return (
            <div className="logo"><img src={GESD_LOGO} alt={"GESD EMSD"}/></div>
        )
    }

    const renderControlPanelButton = () => {
        return (
            <DashboardContext.Consumer>
                {({controlPanelOpen, toggleControlPanel}) => (
                    <Button 
                        arial-label="Control Panel" 
                        variant="secondary" 
                        className="px-3 py-1 me-3 d-uhd4k-none d-uhd8k-none" 
                        onClick={toggleControlPanel}>
                        <FontAwesomeIcon icon={faCog} size="lg" className="me-2"/>
                        <span>{t('common.control-panel')}</span>
                    </Button>
                )}
            </DashboardContext.Consumer>
        )
    }

    const renderUserPanel = () => {
        return (
            <div className="user-panel d-flex align-items-center">
                <ul className="user-action me-3">
                    <li className="text-capitalize">
                        <span className="pe-2">{t('common.welcome')}</span>
                        <span className="">{user}</span>
                    </li>
                    <li><Link className="link" to={""} onClick={onLogoutButtonClick}>{t('common.logout')}</Link></li>
                </ul>
                {renderControlPanelButton()}
            </div>
        )
    }

    return (
        <nav className="navbar navbar-dark bg-dark app-bar">
            <div className="container-fluid px-2">
                <div className="d-flex">
                    {renderDrawerButton()}
                    <BreadCrumb/>
                </div>
                {renderRightPanel()}
            </div>
        </nav>
    )
}

AppBar.defaultProps = {
    hasDrawer: false,
    onAppBarToggle: () => {},
    onControlPanelToggle: () => {}
}

export default AppBar